var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('base-header',{attrs:{"title":"Magento","title-link":"/products","map":['Conjuntos de Atributos']}}),_c('magento-attribute-set-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }